<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre7">
<br class="calibre9" id="calibre_pb_1"/> </p>
<p class="calibre7"> <span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre6">ALL RIGHTS RESERVED:  No part of this book may be reproduced, stored, or transmitted, in any form, without the express and prior permission in writing of the Pen It! Publications.  Book may not be circulated in any form of binding or cover other than that in which it is currently published.  </span> </p>
<p class="calibre7"> <span class="calibre6">This book is licensed for your personal enjoyment only.  All rights are reserved.  Pen It! Publications does not grant you rights to resell or distribute this book without prior written consent of both Pen It! Publications and the copyright owner of this book.  This book must not be copied, transferred, sold or distributed in any way.  </span> </p>
<p class="calibre7"> <span class="calibre6">Disclaimer:  This book may contain adult language, graphic content and some situations that readers may find unacceptable.  Neither Pen It! Publications, or our authors will be responsible for repercussions to anyone who utilizes the subject of this book for illegal, immoral or unethical use. </span> </p>
<p class="calibre7"> <span class="calibre6">This book is a work of fiction, unless otherwise stated.  All characters, places, business, etc. are a work of fiction submitted to Pen It! Publications by the author.  Any resemblance to those living or dead, is purely coincidental.  </span> </p>
<p class="calibre7"> <span class="calibre6">The author is responsible for approval of any and all edits and are the final responsibility of the author.  </span> </p>
<p class="calibre7"> <span class="calibre6">All inquiries regarding the content included in this book should be directed to Pen It! Publications.</span> </p>
<p class="calibre10"> <span class="calibre6">Pen It! Publications, LLC</span> </p>
<p class="calibre10"> <a class="calibre11" href="mailto:penitpublications@yahoo.com"><span class="calibre12">penitpublications@yahoo.com</span></a><span class="calibre6"> </span> </p>
<p class="calibre10"> <a class="calibre11" href="http://www.BuyMeBooksNow.com" target="_blank"><span class="calibre12">www.BuyMeBooksNow.com</span></a> </p>
<p class="calibre10"> <a class="calibre11" href="mailto:penitpublications@yahoo.com"><span class="calibre12">penitpublications@yahoo.com</span></a><span class="calibre6"> </span> </p>
<p class="calibre7"> <span class="calibre13"></span> </p>
<p class="calibre7"> <span class="calibre8" id="calibre_pb_2"></span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_001.vue?517429a4